import { Typography } from '@vivaldis/antd-ui'
import { useTheme } from '@vivaldis/ui'
import { useTranslation } from 'react-i18next'

export const NotSetImageValue = () => {
  const [t] = useTranslation('web_ui')

  const theme = useTheme()
  return (
    <Typography.Text color={theme.gray7}>
      {t('employee_profile.image_not_set')}
    </Typography.Text>
  )
}
